module.exports = __webpack_public_path__ + "static/video01-2be39bb9295f2b0b74b8b6b35c3bda4e.mp4";